import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import { SelectProps } from './Select';

type SelectDesktopProps = Pick<SelectProps, 'items' | 'selectedItems' | 'setSelectedItems'> & {
  itemClick: (val: string | number) => void;
  isMenuOpened: boolean;
  setSearch: (val: string) => void;
  search: string;
  showSearch?: boolean;
  isMultiple: boolean;
};
export default function SelectDesktop({
  items,
  selectedItems,
  setSelectedItems,
  isMenuOpened,
  itemClick,
  setSearch,
  search,
  showSearch,
  isMultiple,
}: SelectDesktopProps) {
  const clearText = selectedItems?.length ? `(${selectedItems?.length})` : '';

  return (
    <div
      className={cn('absolute z-20 grid  w-max min-w-full rounded-b-lg border bg-white', {
        'rounded-t-lg': !isMenuOpened,
        'border-t-0': isMenuOpened,
      })}
    >
      {showSearch && (
        <div className="w-full px-1 pb-1">
          <input
            className={cn(
              'font-the-future font-regular w-full rounded-sm border bg-transparent p-1 outline-hidden',
              'text-description-sm md:text-description-lg text-body-foreground',
            )}
            onChange={(val) => {
              setSearch(val.target.value);
            }}
            value={search}
          ></input>
        </div>
      )}
      <div
        className={cn('flex max-h-[277px] select-none flex-col gap-2 overflow-auto px-2 pt-2', {
          'pb-2': !isMultiple,
        })}
      >
        {items.map((item) => (
          <div
            key={item.value}
            onClick={() => itemClick(item.value)}
            className={cn(
              'group flex cursor-pointer items-center justify-between',
              'hover:bg-input gap-4 rounded-lg px-2 py-1',
              {
                'pl-3': !isMultiple,
                'bg-background text-foreground': selectedItems?.includes(item.value) && !isMultiple,
              },
            )}
          >
            <div className="flex items-center gap-1.5">
              {isMultiple && (
                <StaticIcon
                  className={cn('fill-secondary', {
                    'fill-link': selectedItems?.includes(item.value),
                  })}
                  icon={selectedItems?.includes(item.value) ? IconType.checkBoxSelected : IconType.checkBox}
                />
              )}
              <Text
                content={item.label}
                variant={TextVariant.TextLabel}
                className="text-foreground select-none capitalize"
              />
            </div>
            <Text
              content={item.hint}
              className={cn('invisible select-none capitalize', {
                'group-hover:visible': item.hint,
              })}
              variant={TextVariant.TextDescription}
            />
          </div>
        ))}
      </div>
      {isMultiple && (
        <div className="flex px-2 pb-2 pt-2">
          <span
            onClick={() => setSelectedItems?.([])}
            className={cn('w-full select-none rounded-lg py-1', {
              'decoration-link cursor-pointer underline-offset-4 hover:underline': selectedItems?.length,
            })}
          >
            <Text
              content={`Clear ${clearText}`}
              variant={TextVariant.TextLabel}
              className={cn('text-secondary text-capitalize w-full px-2', {
                'text-link': selectedItems?.length,
              })}
            />
          </span>
        </div>
      )}
    </div>
  );
}
